import { Injectable, inject } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VendorServiceOrder } from '../models';
import { ApiService } from './api.service';

@Injectable()
export class VideoOrderService {
  private apiService = inject(ApiService);

  resource = 'video-orders';

  get(marketingOrderId: string, productCode: string): Observable<VendorServiceOrder[]> {
    const queryParams: any = { marketingOrderId };
    if (productCode) {
      queryParams.productCode = productCode;
    }

    return this.apiService.get(this.resource, queryParams).pipe(
      map((orders: VendorServiceOrder[]) => {
        const videoOrderObjs = [];
        orders.forEach((o: VendorServiceOrder) => {
          videoOrderObjs.push(new VendorServiceOrder(o));
        });
        return videoOrderObjs;
      }),
    );
  }

  // True once the vendor has returned ad results (preview images or stats) for this product's video order.
  async hasAdResults(marketingOrderId: string, productCode: string): Promise<boolean> {
    const videoOrders = await firstValueFrom(this.get(marketingOrderId, productCode));
    const videoOrder = videoOrders?.[0];
    return !!(videoOrder?.finalAdImages?.length || videoOrder?.stats);
  }

  /**
   * This service is NOT To be used widely in the app. It is a tactical approach to re-submitting
   * video order requests under very specific conditions. Currently it is hidden behind a feature flag
   * that will only be enabled for a single user. The server resource is also hidden behind the same feature flag.
   */
  async resubmit(marketingOrderId: string, productCode: string) {
    const path = `${this.resource}/send-request/${marketingOrderId}`;
    return this.apiService.get(path, { productCode }).toPromise();
  }
}
